module.exports = __webpack_public_path__ + "static/sec7-bg-0e9e46c29039ebdaaecef8b1af04f461.jpg";